// extracted by mini-css-extract-plugin
export var displayNone = "_lr-6";
export var imgContainer = "_lr-2";
export var overflowHidden = "_lr-3";
export var productInfoCardButtonContainer = "_lr-5";
export var productTitleText = "_lr-4";
export var rightArrow = "_lr-1";
export var rightArrowContainer = "_lr-0";